'use strict';

import {ferry} from '../../services/ferry/ferry';
import {currentDate} from '../../services/constants/calculate';
import {rightName, hasEdit, hasView, hasPersonal, RightsDictionary, rightLevel} from '../../services/contacts/rights';

export class SessionState {
    company: string;
    user_id: string;
    role: string;
    paying: boolean;
    intercom_hash: string;
    rights: RightsDictionary;
    user_zephyr_slug: string;
    company_zephyr_id: number;
    cookie: string;
    demo_user: boolean;

    constructor() {
        this.init();
    }

    init() {
        const cookies: RightsDictionary = document.cookie
            .split(';')
            .reduce(function(cookie_obj: RightsDictionary, cookie_str: string): RightsDictionary {
                let cookie_parts = cookie_str.trim().split('=');
                cookie_obj[cookie_parts[0]] = <rightLevel>cookie_parts[1];
                return cookie_obj;
            }, {} as RightsDictionary);

        if (!cookies['sharewave_JWT']) {
            return;
        }

        let jwt = JSON.parse(atob(cookies['sharewave_JWT'].split('.')[1]));

        // note that we don't verify the validity of the signature of the token, as we don't really care
        this.company = jwt.company;
        this.user_id = jwt.user_id || jwt.userId; // transitional. userId will be replaced with user_id in ferry/fundus
        this.role = jwt.role;
        this.paying = jwt.paying;
        this.intercom_hash = jwt.intercom;
        this.rights = jwt.rights;
        this.user_zephyr_slug = jwt.user_zephyr_slug;
        this.company_zephyr_id = jwt.company_zephyr_id;
        this.cookie = cookies['sharewave_JWT'];
        this.demo_user = jwt.demo_user;
    }

    refreshCookie() {
        return ferry.call('/session/refresh').then(() => {
            this.init();
        });
    }

    storage_set(type: string, value: any) {
        let new_key = this.company + type;
        return sessionStorage.setItem(new_key, JSON.stringify(value));
    }

    storage_get(type: string) {
        // TODO: use only new_key once there has been time for everyone to have saved with the new storage location
        let old_key = this.company + this.role + type;
        let new_key = this.company + type;
        try {
            return angular.fromJson(sessionStorage.getItem(new_key)) ? angular.fromJson(sessionStorage.getItem(new_key)) : (angular.fromJson(sessionStorage.getItem(old_key)) ? angular.fromJson(sessionStorage.getItem(old_key)) : null);
        }
        catch (e) {
            return null;
        }
    }

    storage_remove(type: string) {
        let new_key = this.company + type;
        sessionStorage.removeItem(new_key);
    }

    fetchDate() {
        let date = sessionStorage.getItem(this.company + 'ownership-currentDate');
        if (date) {
            return new Date(date);
        } else {
            return currentDate();
        }
    }

    setDate(date: any) {
        if (date && Object.prototype.toString.call(date) === '[object Date]') {
            sessionStorage.setItem(this.company + 'ownership-currentDate', date.toISOString());
        }
    }

    has_document_edit() {
        return hasEdit(this.rights, 'documents');
    }
    has_full_document() {
        return hasView(this.rights, 'documents');
    }
    has_captable_edit() {
        return hasEdit(this.rights, 'ownership');
    }
    has_full_captable() {
        return hasView(this.rights, 'ownership');
    }
    has_personal_captable() {
        return hasPersonal(this.rights, 'ownership');
    }
    hasEdit(right: rightName) {
        return hasEdit(this.rights, right);
    }
    hasView(right: rightName) {
        return hasView(this.rights, right);
    }
    canRequestValuation() {
        return this.hasEdit('valuation') && this.hasEdit('billing');
    }
}

export const sessionState = new SessionState();



// WEBPACK FOOTER //
// ./_src/services/sessionState/sessionState.ts